import React from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Divider, Stack } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export default function BlogSingleAreaSidebar({ categoriesList, pastPost }) {
  return (
    <Box className="sidebar-wrapper" sx={{ pt: 2, position: 'sticky', top: 20 }}>
      
      
      <Box sx={{ mb: 5 }}>
        <Typography 
          variant="overline" 
          sx={{ fontWeight: 800, letterSpacing: 2, color: '#999', display: 'block', mb: 1 }}
        >
          Explore
        </Typography>
        <Typography 
          variant="h5" 
          sx={{ fontFamily: 'serif', fontWeight: 700, mb: 2 }}
        >
          Categories
        </Typography>
        <Divider sx={{ mb: 2, width: '40px', height: '3px', bgcolor: '#000' }} />
        
        <List sx={{ p: 0 }}>
          <ListItem disablePadding>
            <ListItemButton 
              component="a" 
              href="/stories"
              sx={{ px: 0, '&:hover': { bgcolor: 'transparent', color: '#888' } }}
            >
              <ListItemText 
                primary="ALL STORIES" 
                primaryTypographyProps={{ fontSize: '13px', fontWeight: 700, letterSpacing: 1 }} 
              />
              <ChevronRightIcon sx={{ fontSize: '16px' }} />
            </ListItemButton>
          </ListItem>
          
          {categoriesList.map((data, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton 
                component="a" 
                href={`/stories?categories=${data.id}`}
                sx={{ px: 0, '&:hover': { bgcolor: 'transparent', color: '#888' } }}
              >
                <ListItemText 
                  primary={data.name.toUpperCase()} 
                  primaryTypographyProps={{ fontSize: '13px', fontWeight: 600, letterSpacing: 1 }} 
                />
                <ChevronRightIcon sx={{ fontSize: '16px' }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>

      
      <Box>
        <Typography 
          variant="overline" 
          sx={{ fontWeight: 800, letterSpacing: 2, color: '#999', display: 'block', mb: 1 }}
        >
          Latest
        </Typography>
        <Typography 
          variant="h5" 
          sx={{ fontFamily: 'serif', fontWeight: 700, mb: 3 }}
        >
          Recent Posts
        </Typography>

        <Stack spacing={3}>
          {pastPost.map((data, index) => {
            let srcURL = '';
            try {
              const media = data._embedded?.["wp:featuredmedia"]?.[0];
              if (media?.source_url) {
                srcURL = media.source_url.replace(
                  "188.166.186.239",
                  "apiblog.leon-gallery.com"
                );
              }
            } catch (err) {
              console.warn('Image error', err);
            }

            return (
              <Box 
                key={index}
                sx={{ 
                  display: 'flex', 
                  gap: 2, 
                  cursor: 'pointer',
                  '&:hover': { '& .post-title': { color: '#666' } }
                }}
                onClick={() => window.location.href = `/stories/${data.slug}`}
              >
                
                <Box
                  sx={{
                    width: '80px',
                    height: '80px',
                    flexShrink: 0,
                    bgcolor: '#f7f7f7',
                    backgroundImage: `url(${srcURL})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    border: '1px solid #eee'
                  }}
                />

                
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Typography 
                    className="post-title"
                    variant="body2" 
                    sx={{ 
                      fontWeight: 700, 
                      lineHeight: 1.3,
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      transition: '0.2s',
                      fontFamily: 'serif'
                    }}
                  >
                    {data.title?.rendered}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#aaa', mt: 0.5 }}>
                    {new Date(data.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Box>
  );
}